import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { of } from 'rxjs';
import {
    FilterSearchingInformeImportacionesViewModel,
    FilterSearchingInformeTasasViewModel,
    InformeTasasItemResultsViewModel,
    FilterSearchingInformeInspeccionesViewModel,
    InformeTasasExportacionItemResultsViewModel,
    FilterSearchingInformeTasasExportacionViewModel,
    FilterSearchingInformeExportacionesViewModel,
    FilterSearchingInformeInspeccionesExportacionViewModel,
} from './informes.types';
import { Tc } from '../../core/_infrastructure/types/common';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class InformesService {
    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    //*** INFORME PANTALLA INICIAL ***//
    getAllTiposInforme(params: HttpParams): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/mantenimiento/informes/tiposinforme', { params: params }).pipe();
    }

    //*** INFORME GENERAL IMPORTACIONES ***//
    postInformeImportacionesPagedByFilter(model: FilterSearchingInformeImportacionesViewModel): Observable<any> {
        return this.http
            .post<FilterSearchingInformeImportacionesViewModel>(this.baseUrl + 'api/mantenimiento/informes/postInformeImportacionesPagedByFilter', model)
            .pipe();
    }

    exportInformeImportaciones(model: FilterSearchingInformeImportacionesViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/informes/postExportExcelByFilterInformeImportaciones', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    search(term: string): Observable<Tc[]> {
        return this.http.get<Tc[]>('api/mantenimiento/informes/filteredTaricInformes' + '?term=' + term).pipe();
    }

    //*** INFORME GENERAL EXPORTACIONES ***//
    postInformeExportacionesPagedByFilter(model: FilterSearchingInformeExportacionesViewModel): Observable<any> {
        return this.http
            .post<FilterSearchingInformeExportacionesViewModel>(this.baseUrl + 'api/mantenimiento/informes/postInformeExportacionesPagedByFilter', model)
            .pipe();
    }

    exportInformeExportaciones(model: FilterSearchingInformeExportacionesViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/informes/postExportExcelByFilterInformeExportaciones', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    searchExportaciones(term: string): Observable<Tc[]> {
        return this.http.get<Tc[]>('api/mantenimiento/informes/filteredTaricInformes' + '?term=' + term).pipe();
    }

    //*** INFORME GENERAL TASAS IMPORTACIÓN ***//
    getInformeTasasPagedByFilter(params: HttpParams): Observable<InformeTasasItemResultsViewModel> {
        return this.http
            .get<InformeTasasItemResultsViewModel>(this.baseUrl + 'api/mantenimiento/informes/pagedByFilterInformeTasas', { params: params })
            .pipe();
    }

    exportInformeTasas(model: FilterSearchingInformeTasasViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/informes/postExportExcelByFilterInformeTasas', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    //*** INFORME GENERAL TASAS EXPORTACIÓN ***//
    getInformeTasasExportacionPagedByFilter(params: HttpParams): Observable<InformeTasasExportacionItemResultsViewModel> {
        return this.http
            .get<InformeTasasExportacionItemResultsViewModel>(this.baseUrl + 'api/mantenimiento/informes/pagedByFilterInformeTasasExportacion', {
                params: params,
            })
            .pipe();
    }

    exportInformeTasasExportacion(model: FilterSearchingInformeTasasExportacionViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/informes/postExportExcelByFilterInformeTasasExportacion', model, {
                observe: 'response',
                responseType: 'blob',
            })
            .pipe();
    }

    //*** INFORME GENERAL INSPECCIONES ***//
    getDecisionInspeccion(): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/mantenimiento/informes/decisioninspeccion').pipe();
    }

    postInformeInspeccionesPagedByFilter(model: FilterSearchingInformeInspeccionesViewModel): Observable<any> {
        return this.http
            .post<FilterSearchingInformeInspeccionesViewModel>(this.baseUrl + 'api/mantenimiento/informes/postInformeInspeccionesPagedByFilter', model)
            .pipe();
    }

    exportInformeInspecciones(model: FilterSearchingInformeInspeccionesViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/informes/postExportExcelByFilterInformeInspecciones', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    //*** INFORME GENERAL INSPECCIONES EXPORTACION ***//
    postInformeInspeccionesExportacionPagedByFilter(model: FilterSearchingInformeInspeccionesExportacionViewModel): Observable<any> {
        return this.http
            .post<FilterSearchingInformeInspeccionesExportacionViewModel>(
                this.baseUrl + 'api/mantenimiento/informes/postInformeInspeccionesExportacionPagedByFilter',
                model,
            )
            .pipe();
    }

    exportInformeInspeccionesExportacion(model: FilterSearchingInformeInspeccionesExportacionViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/informes/postExportExcelByFilterInformeInspeccionesExportacion', model, {
                observe: 'response',
                responseType: 'blob',
            })
            .pipe();
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            //this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
